<template>
  <div class="wrapper">
    <ul class="listing">
      <li
        v-for="([k, v], i) in list"
        :key="`group-${k}`"
        class="listing__group"
      >
        <strong class="listing__group__label">{{ k }}</strong>
        <ul class="listing__group__links">
          <li
            v-for="(item, i) in v"
            :key="`link-${item}`"
            class="listing__group__link"
          >
            {{ cleanBackslash(item) }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { cleanBackslash } from '@/utils/string'

const props = defineProps({
  content: {
    type: Array as PropType<string[]>,
    required: true,
  },
})

const list = new Map<string, string[]>()
;[...props.content]
  .sort((a, b) => a.localeCompare(b))
  .forEach(item => {
    const firstLetter = item.charAt(0)
    list.set(
      firstLetter,
      props.content?.filter(i => i.startsWith(firstLetter))
    )
  })
</script>

<style lang="scss" scoped>
.listing {
  list-style: none;
  margin: 0;
  padding: 0;
  line-height: 1.75;

  @include mq(s) {
    columns: 2;
    column-gap: 3rem;
  }

  @include mq(xl) {
    columns: 3;
  }

  @include mq(xxxl) {
    columns: 4;
  }
}

.listing__group {
  position: relative;
  padding-left: 2em;
  break-inside: avoid;
}

.listing__group__label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  margin-bottom: 0.5em;
  break-after: avoid;
}

.listing__group__link {
  list-style-type: none;
}

.listing__group__links {
  padding-left: 0;
}
</style>
